/* global axios */
import ApiClient from './ApiClient';

// Short links are proxied to the self-hosted Shlink instance by the Rails
// backend (Api::V1::Accounts::ShortLinksController). get() lists, create()
// shortens a long URL.
class ShortLinksAPI extends ApiClient {
  constructor() {
    super('short_links', { accountScoped: true });
  }

  // Paginated per-visit rows for a short code (geolocation, time, device, bot).
  visits(shortCode, { page = 1, itemsPerPage = 50 } = {}) {
    return axios.get(`${this.url}/${shortCode}/visits`, {
      params: { page, items_per_page: itemsPerPage },
    });
  }
}

export default new ShortLinksAPI();
